import { Component } from 'js-component-framework';
import fastdom from 'fastdom';

/**
 * Animates the Circular Counter block's SVG.
 */
class CircularCounter extends Component {
  /**
   * Create a new CircularCounter.
   *
   * @constructor
   */
  constructor(config) {
    super(config);

    this.init = this.init.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.setAnimationClassname = this.setAnimationClassname.bind(this);

    this.init();
  }

  /**
   * Set the classname to kick off the animation.
   */
  setAnimationClassname() {
    const { circle } = this.children;
    circle.classList.add('circle__counter-stroke--animate');
  }

  init() {
    /**
     * Intersection Observer for starting animation when the component is fully visible.
     *
     * @type {IntersectionObserver}
     */
    this.observer = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 },
    );

    // Observe the element.
    this.observer.observe(this.element);
  }

  /**
   * Handle IntersectionObserver changes.
   *
   * @param {IntersectionObserverEntry} entries The IntersectionObserver entries.
   */
  handleIntersection(entries) {
    const [entry] = entries;

    if (entry.isIntersecting) {
      fastdom.mutate(this.setAnimationClassname);

      // No need to observe the element anymore.
      this.observer.unobserve(this.element);
    }
  }
}

/**
 * The CircularCounter cofiguration.
 *
 * @type {Object}
 */
const circularCounterConfig = {
  name: 'circular-counter',
  class: CircularCounter,
  querySelector: {
    circle: '.circle__counter-stroke',
  },
};

export default circularCounterConfig;
